export default {
  text: {
    en: 'Add fragrances, skincare and makeup products to your subscription queue',
  },
}
